import { Button, IconButton, InputAdornment, TextField, Tooltip } from "@mui/material";
import { useState } from "react";
import { DynamicFormControl } from "../../../";
import { WpAlert } from "../../helpers/alert";
import { LocalizedStringsMethods } from "react-localization";
import { getLocalizedStringMethods, localizeText, useTranslateDetection } from "../../helpers/translate-helper";


function FileUploadControl(props: DynamicFormControl) {
    const [value, setValue] = useState(props.value ?? '');
    const [isValid, setIsValid] = useState(true);
    const [selectedFiles, setSelectedFiles] = useState<FileList>();
    const [alertOpen, setAlertOpen] = useState(false);

    const { currentLanguage } = useTranslateDetection();
    let strings: LocalizedStringsMethods | null = getLocalizedStringMethods(props, currentLanguage);
    let label = props.label;

    if (strings != null && label != null) {
        const localization = localizeText(strings, label);
        label = localization.localization;
    }

    const handleChange = (event: any) => {
        const files = event.target.files as FileList;

        if (props.fileUploadOptions?.extensionRestrictions != null) {
            let validFiles = true;

            for (let i = 0; i < files.length; i++) {
                const fileExt = `.${files[i].name.split('.').pop()}`;
                const hasValid = props.fileUploadOptions?.extensionRestrictions.some(x => x === fileExt);

                validFiles = validFiles && hasValid;
            }

            if (!validFiles) {
                setAlertOpen(true);
                return;
            }
        }

        setSelectedFiles(files);
        // const value = event.target.value as string;

        if (props.setState && files != null) {
            let stringValue: string[] = [];
            for (let i = 0; i < files.length; i++) {
                stringValue.push(files[i].name);
            }
            props.setState(stringValue);
        }

        if (props.fileUploadOptions?.setFiles && files != null) {
            const fileArray = [];

            for (var i = 0; i < files.length; i++) {
                fileArray.push(files[i]);
            }

            props.fileUploadOptions.setFiles(fileArray);
        }

        //setValue(value);
        // setEnabled(value != null && value !== '');

        // if (props.regexValidation != null) {
        //     const regex = new RegExp(props.regexValidation);
        //     if (value) {
        //         setIsValid(regex.test(value));
        //     } else {
        //         setIsValid(true);
        //     }
        // }
    };

    const [enabled, setEnabled] = useState(props.disabled ? false : true);
    const handleClickEnableDisable = () => {
        if (props.setDisabled) {
            props.setDisabled(enabled);
        }
        setEnabled(!enabled);
    };
    const handleMouseDownEnableDisable = (event: any) => {
        event.preventDefault();
    };

    if (props.updater != null) {
        props.updater.setValue = value => {
            setValue(value ?? '');
        };
    }

    function SelectedFiles() {
        if (selectedFiles == null) {
            return null;
        }

        let elements = [];
        for (var i = 0; i < selectedFiles.length; i++) {
            elements.push(<span>{selectedFiles[i].name}{i < selectedFiles.length - 1 ? ', ' : ''}</span>)
        }

        return <span style={{ marginLeft: 10 }}>{elements}</span>;
    }

    return (
        <div>
            <input
                accept={props.fileUploadOptions?.fileAccept}
                style={{ display: 'none' }}
                id={props.id}
                multiple={props.fileUploadOptions?.multipleFiles}
                onChange={handleChange}
                disabled={props.disabled}
                type="file"
            />
            <label htmlFor={props.id}>
                <Button variant="outlined" component="span">
                    {label}
                </Button>
            </label>

            <SelectedFiles></SelectedFiles>

            <WpAlert message={`You may only select file(s) with the following extension types: ${props.fileUploadOptions?.extensionRestrictions?.join(' ')}`} severity="warning" open={alertOpen} setOpen={setAlertOpen} />
        </div>
    )
}


export default FileUploadControl;